var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6H22.654L22.26 2.649C22.082 1.139 20.802 0 19.281 0H4.72C3.199 0 1.918 1.139 1.741 2.649L1.347 6H0V8H1.346L1.74 11.351C1.918 12.861 3.198 14 4.719 14H19.28C20.801 14 22.082 12.861 22.259 11.351L22.653 8H23.999L24 6ZM3.727 2.883C3.786 2.38 4.213 2 4.72 2H19.281C19.788 2 20.216 2.379 20.274 2.883L20.641 6H3.36L3.727 2.883ZM20.274 11.117C20.215 11.62 19.788 12 19.281 12H4.72C4.213 12 3.785 11.621 3.727 11.117L3.36 8H9.219L9.718 10H14.28L14.779 8H20.638L20.271 11.117H20.274Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.a624556f73e3c625e850017e6df61531.svg";
export { ForwardRef as ReactComponent };